import ClickAwayHandler from '@/components/ui/wrapper/click-away';

import { useSymbolFilters } from '../hooks/useSymbolFilters';
import { ALL_SYSTEMS } from '../state';
import {
  GenericObject,
  FILTERS,
  FILTER_LABELS as LABELS,
  TKSystem,
} from '../types';

import { MultilevelMenu } from './multi-level-menu';
import { MultiLevelSystem } from './multi-level-system';

// selected filer name displayed at dropdown button!
const filterTypes: GenericObject = {
  [FILTERS.DEFAULT]: LABELS.DEFAULT,
  [FILTERS.ALL]: LABELS.ALL,
  [FILTERS.DUCTS]: LABELS.DUCTS,
  [FILTERS.PIPES]: LABELS.PIPES,
  [FILTERS.DLENT]: LABELS.DLENT,
  [FILTERS.PLENT]: LABELS.PLENT,
  [FILTERS.PLMBS]: LABELS.PLMBS,
  [FILTERS.MXDUCT]: LABELS.MXDUCT,
  [FILTERS.MXPIPE]: LABELS.MXPIPE,
  [FILTERS.EQMT]: LABELS.EQMT,
  [FILTERS.OFST]: LABELS.OFST,
  [FILTERS.MXPIBO]: LABELS.MXPIBO,
};

/**
 * Use shared symbol filter
 * @log removed `hide size text` checkbox - 2025/08/21
 */
export const FilterSymbolSection = ({
  currentFilter,
  systems,
  projectSystems,
  onFilterChange,
}: {
  projectSystems: string[];
  systems: TKSystem[];
  currentFilter: string;
  onFilterChange: (filter: string) => void;
}) => {
  const { selectedSystem, ...filters } = useSymbolFilters(
    currentFilter,
    onFilterChange,
  );
  const filterLabelFull = filterTypes[currentFilter] || currentFilter;
  const systemLabelFull =
    selectedSystem == ALL_SYSTEMS.value
      ? ALL_SYSTEMS.label
      : filters.systemByShort(selectedSystem, systems);
  return (
    <ClickAwayHandler
      classNames="tool-section-md mr-4 border-r border-gray hidden xl:flex"
      handleClickAway={filters.closeDropdownMenuHandler}
    >
      {/* == section - 1: mult-level symbol filters  */}
      <div className="left-part w-full">
        {/* === row one === */}
        <div className="filter-label-box flex w-full">
          <h3 className="text-tiny color-blue-gray uppercase w-14 flex-1">
            Filters
          </h3>
          {/* inverse filtering */}
          <label
            htmlFor="inverse-filter"
            className="hover:text-primary-over flex-1"
            title="Cover current symbols"
          >
            <input
              id="inverse-filter"
              type="checkbox"
              className="mr-1 mt-0.5 select-none inline-block align-top"
              checked={filters.inverseChecked}
              onChange={filters.reverseCheckHandler}
            />
            <span className="inline-block text-xs select-none align-top ">
              Inverse Filtering
            </span>
          </label>
        </div>
        {/* === row two === */}
        <div className="dropdown-selection-row flex gap-3 mt-px">
          <div className="filter-options mt-0 relative">
            {/* symbol type/group filter */}
            <button
              type="button"
              title={filterLabelFull}
              className="block select frame-input-select color-primary icon-select-short w-28"
              onClick={() => filters.menuDropDownOpenHandler('mlm')}
            >
              {filterLabelFull.substring(0, 13)}
            </button>
            {/* dynamically popped up drop down menu, hidden by default */}
            <MultilevelMenu handleFilterChange={filters.handleFilterChange} />
          </div>
          <div className="filter-options mt-0 relative">
            <button
              type="button"
              className="system-selector select frame-input-select color-primary icon-select-short w-28"
              onClick={() => filters.menuDropDownOpenHandler('mls')}
            >
              {systemLabelFull}
            </button>
            {/* dynamically popped up drop down system menu, hidden by default */}
            <MultiLevelSystem
              systems={systems}
              customSystems={projectSystems}
              handleSystemFilter={filters.handlerSystemChange}
            />
          </div>
        </div>
      </div>
    </ClickAwayHandler>
  );
};
